// extracted by mini-css-extract-plugin
export var closeButton = "_nl-2";
export var closeButtonIcon = "_nl-3";
export var lightboxContent = "_nl-1";
export var lightboxOverlay = "_nl-0";